import { BettingTabs } from "types/BetTypes";
import { z, type infer as zInfer } from "zod";

export enum CampaignPurposeEnum {
  /**
   * "Double you winnings" type promotion that is attached to a betting market and automatically claimed by the user when they bet on it.
   *
   */
  WINNINGS_BOOST = "WINNINGS_BOOST",

  /**
   *  "Lose one leg of a 4+ leg multi and get cashback" type promotion
   *  that is automatically claimed by the user when qualifying bet is accepted.
   *
   */
  MULTI_CASHBACK = "MULTI_CASHBACK",
  DEFAULT_REFERRAL = "DEFAULT_REFERRAL",
  REFERRAL = "REFERRAL",
  PROMOTION = "PROMOTION",

  DEFAULT_DEPOSIT_BONUS = "DEFAULT_DEPOSIT_BONUS",
  DEPOSIT_BONUS = "DEPOSIT_BONUS",
  PER_CLAIM_DEPOSIT_BONUS = "PER_CLAIM_DEPOSIT_BONUS",

  BTAG_REFERRAL = "BTAG_REFERRAL",
}

export const promotionCampaign = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().optional(),
  openToAllEligibleUsers: z.boolean(),
  promotions: z
    .record(
      z.string(),
      z.object({
        name: z.string(),
        currency: z.string(),
        description: z.string(),
        code: z.string().optional(),
        purpose: z.enum(CampaignPurposeEnum),
        termsOfUse: z.string().optional(),
      }),
    )
    .nullable(),
  automation: z
    .object({
      id: z.string(),
      type: z.enum(["TRIGGER", "PROMOTION", "TOKEN"]),
      eventBasedTokens: z.boolean().optional(),
      excludedCampaignIds: z.array(z.string()),
    })
    .optional(),
  bettingTabs: z.nativeEnum(BettingTabs).array().optional(),
  termsOfUse: z.string().optional(),
});

export type PromotionCampaign = zInfer<typeof promotionCampaign>;
